export default {
	firstName: "First Name",
	lastName: "Last Name",
	nickname: "Nickname",
	email: "Email",
	name: "Name",
	birthDate: "Birth Date",
	firstVisitDate: "First Visit",
	gender: "Gender",
	cpf: "CPF",
	rg: "ID",
	maritalStatus: "Marital Status",
	type: "Type",
	phone: "Phone",
	mobile: "Mobile",
	whatsappOptIn: "Agrees to receive WhatsApp notices",
	whatsappOptInHint: "The person authorizes receiving temple charges and notices via WhatsApp, sent from ORI's official number (consent under LGPD, Brazil's data protection law)",
	address: "Address",
	street: "Street",
	addressNumber: "Number",
	addressComplement: "Complement",
	neighborhood: "Neighborhood",
	city: "City",
	state: "State",
	zipCode: "Postal code",
	zipCodeNotFound: "Postal code not found",
	zipCodeLookupFailed: "Could not look up the postal code right now — fill in the address manually",
	paiDeCabeca: "Father of the Head",
	maeDeCabeca: "Mother of the Head",
	fatherName: "Father's Name",
	motherName: "Mother's Name",
	nationality: "Nationality",
	occupation: "Occupation",
	emergencyContactName: "Emergency Contact",
	emergencyContactPhone: "Emergency Phone",
	bloodType: "Blood Type",
	healthNotes: "Health and Medication",
	healthNotesHint:
		"Health conditions, allergies and ongoing medication. Sensitive data under LGPD — only temple leaders can see and edit it.",
	healthAdminOnly: "Only temple leaders can see health data",
	imageUseConsent: "Authorizes image use",
	imageUseConsentHint:
		"The person authorizes the temple to use their image in photos and videos (consent under LGPD)",
	imageUseConsentSince: "Authorized on {date}",
	notes: "Notes",
	sections: {
		personal: "Details",
		address: "Address",
		family: "Family",
		emergency: "Emergency contact",
		health: "Health",
		consents: "Authorizations",
		permissions: "Permissions",
		spiritual: "Spiritual",
	},
	fullRegistration: "Full registration",
	tabs: {
		basic: "Basic Information",
		functions: "Functions",
		guides: "Guides",
		journey: "Journey",
	},
	types: {
		medium: "Medium",
		assistencia: "Assistance",
	},
	// Keys match the Prisma enum values — the label comes straight from
	// `people.genders[person.gender]`, no mapping table in between.
	genders: {
		MALE: "Male",
		FEMALE: "Female",
		OTHER: "Other",
	},
	maritalStatuses: {
		SINGLE: "Single",
		MARRIED: "Married",
		STABLE_UNION: "Domestic partnership",
		DIVORCED: "Divorced",
		WIDOWED: "Widowed",
	},
	edit: "Edit Person",
	create: "Create Person",
	messages: {
		invalidForm: "Check the highlighted fields before saving",
		loading: "Loading person...",
		loadError: "Error loading person",
		created: "{name} was created successfully",
		updated: "{name} was updated successfully",
		deleted: "{name} was deleted successfully",
		createError: "Error creating person",
		updateError: "Error updating person",
		deleteError: "Error deleting person",
	},
	mediums: {
		searchPlaceholder: "Search medium...",
		filters: {
			all: "All",
			journeyStage: "Journey Stage",
			orixa: "Orixa",
			function: "Function",
		},
		newMedium: "New Medium",
		table: {
			code: "Code",
			name: "Name",
			journey: "Journey",
			orixas: "Orixas",
			function: "Function",
			contact: "Contact",
		},
		tooltips: {
			view: "View Profile",
			edit: "Edit",
			journey: "Manage Journey",
		},
		empty: {
			title: "No mediums found",
			description: "Try adjusting filters or add a new medium to the line",
		},
		stats: {
			total: "Total",
			active: "Active",
		},
	},
	consultants: {
		empty: {
			description: "Try adjusting the filters or register a new consultant",
			title: "No consultants found",
		},
		filters: {
			all: "All",
			recent: "Recent",
			withReturn: "With Return",
			withTickets: "With Tickets",
		},
		neverAttended: "Never attended",
		newConsultant: "New Consultant",
		return: "Return",
		searchPlaceholder: "Search consultant...",
		stats: {
			returns: "Returns",
			total: "Total",
			withTickets: "With Tickets",
		},
		table: {
			birthday: "Birthday",
			code: "Code",
			contact: "Contact",
			lastVisit: "Last Visit",
			name: "Name",
			registration: "Registration",
			status: "Status",
			visits: "Visits",
		},
		ticket: "ticket",
		tickets: "tickets",
		tooltips: {
			alreadyHasTicket: "Consultant already has an active ticket in this ritual",
			edit: "Edit",
			history: "History",
			newTicket: "New Ticket",
		},
	},
	photo: {
		addPhoto: "Tap to add photo",
		capture: "Capture",
		closeCamera: "Close camera",
		dragHere: "Drag an image or click to select",
		maxSize: "Maximum size: {size}MB",
		retake: "Retake",
		tabFile: "File",
		tabWebcam: "Webcam",
		upload: "Update Photo",
		uploadError: "Error updating photo",
		uploadSuccess: "Photo updated successfully",
		webcamError: "Could not access the camera",
	},
	roleHistory: {
		loadError: "Error loading journey history",
	},
	archive: {
		dialogTitle: "Archive Person",
		archiveAction: "Archive",
		unarchiveAction: "Unarchive",
		blockedByFinancialHistory: "This person has financial movements and cannot be deleted — their history is part of the accounts. Archive instead: they leave the lists, open charges are cancelled and the whole trail is preserved. You can unarchive later.",
		blockedByMandate: "This person has an ACTIVE automatic debit. Cancel it first, otherwise charging continues at the payment provider even with the record out of the lists.",
		reasonLabel: "Reason for archiving (optional)",
		reasonPlaceholder: "e.g. moved away, left the house",
		archived: "{name} was archived.",
		unarchived: "{name} is back in the lists.",
		error: "Could not complete the archiving.",
		banner: "Person archived by {user} on {date}. They do not appear in day-to-day lists.",
		filterLabel: "Archived",
	},
	deleteDialog: {
		title: "Permanently Delete Person",
		warning: "This action is irreversible and will permanently delete all data related to this person:",
		items: {
			journeyHistory: "Journey history and hierarchy",
			tickets: "Attendance tickets",
			messages: "Messages and notes",
			returns: "Returns",
			guides: "Guide associations",
			functions: "Assigned functions",
			financial: "Subscriptions and financial transactions",
		},
		impactTitle: "What this person has today:",
		impact: {
			openCharges: "Open charges",
			paidMovements: "Recorded payments",
			subscriptions: "Active subscriptions",
			tickets: "Service tickets",
			messages: "Messages",
			nothing: "Nothing recorded — the record can be deleted with no loss.",
		},
		codeInstruction: "To confirm, type the code below:",
		codePlaceholder: "Type the confirmation code",
		codeError: "Incorrect code",
		deleting: "Deleting...",
	},
	mergeDialog: {
		menuLabel: "Duplicate",
		title: "Merge person into another",
		warning: "This action is irreversible. All links of \"{name}\" (journey, tickets, messages, returns, guides, functions, financial) will be moved to the selected person and \"{name}\" will be deleted.",
		description: "Select the person who will receive all the history:",
		destinationLabel: "Destination person",
		destinationHint: "The person who will keep all the current person's links",
		sameAsSourceError: "Destination person cannot be the same as the source",
		codeInstruction: "To confirm, type the code below:",
		codePlaceholder: "Type the confirmation code",
		codeError: "Incorrect code",
		confirm: "Merge and remove",
		merging: "Merging...",
		successMessage: "{source} was successfully merged into {destination}",
		errorMessage: "Error merging persons",
	},
};
